import { render, staticRenderFns } from "./comp_PaymentInstructions.vue?vue&type=template&id=2ac56d64&"
import script from "./comp_PaymentInstructions.vue?vue&type=script&lang=js&"
export * from "./comp_PaymentInstructions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports